export default `
<div class="upload-btn-container">
  <a href="" class="btn btn-filled upload-btn btn-blue">Choose File</a>
  <span class="filename">{{$ctrl.filename}}</span>
  <input type="file" class="file" name="file" ng-attr-accept="{{$ctrl.accept}}">
</div>
`;
